import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the KontiConnect (integrations) module.
 */
export const KONTI_CONNECT_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/konti-connect/integrations',
    labelKey: 'KontiConnect.integrations',
    icon: '/assets/tablerIcons/outline/plug.svg',
    moduleId: 27,
    groupLabelKey: 'MenuRoutes.group.kontiConnectViews'
  }
];
